import { DiagnosticsData } from '../../../shared/types/diagnosticsData.ts';
import { getStatusMarker } from '../../utils/getStatusMarker.ts';


interface Props {
    diagnosticsData: DiagnosticsData | undefined;
}

export function ServerHealth({
    diagnosticsData,
}: Props) {
    if (!diagnosticsData) return null;
    return (
        <div style={{ fontSize: '1.5em', textAlign: 'center' }}>
            {getStatusMarker(diagnosticsData?.overallStatus)} {diagnosticsData?.conclusion}
        </div>
    )
}